import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NumberOnlyDirective } from './number-only.directive';

@NgModule({
	declarations: [NumberOnlyDirective],
	exports: [NumberOnlyDirective],
	imports: [CommonModule],
})
export class NumberOnlyModule {}
